// import React, { useEffect, useRef, useState } from "react";

// const CareerSection = () => {
//   const sectionRef = useRef(null);
//   const [animatedButtons, setAnimatedButtons] = useState([]);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const buttons = [0, 1, 2, 3];
//             buttons.forEach((buttonIndex, index) => {
//               setTimeout(() => {
//                 setAnimatedButtons((prev) => [...prev, buttonIndex]);
//               }, index * 300);
//             });
//           }
//         });
//       },
//       { threshold: 0.3 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div ref={sectionRef} style={styles.container}>
//       {/* Text Section */}
//       <div style={styles.textSection}>
//         <p style={styles.text}>
//           At ENVISION, you'll supercharge your potential. You'll find your
//           career. And you'll find your spark. All at a place that knows that
//           helping our clients stay on top starts by putting our people first. We
//           offer:
//         </p>
//         <div style={styles.features}>
//           <div
//             style={{
//               ...styles.card,
//               ...styles.card1,
//               transform: animatedButtons.includes(0)
//                 ? "translateY(0)"
//                 : "translateY(100px)",
//               opacity: animatedButtons.includes(0) ? 1 : 0,
//               transition: "transform 0.8s ease, opacity 0.8s ease",
//             }}
//           >
//             <span style={styles.icon}>📂</span>
//             Career opportunities on your terms
//           </div>
//           <div
//             style={{
//               ...styles.card,
//               ...styles.card2,
//               transform: animatedButtons.includes(1)
//                 ? "translateY(0)"
//                 : "translateY(100px)",
//               opacity: animatedButtons.includes(1) ? 1 : 0,
//               transition: "transform 0.8s ease, opacity 0.8s ease",
//             }}
//           >
//             <span style={styles.icon}>✨</span>
//             Enriching job experiences
//           </div>
//           <div
//             style={{
//               ...styles.card,
//               ...styles.card3,
//               transform: animatedButtons.includes(2)
//                 ? "translateY(0)"
//                 : "translateY(100px)",
//               opacity: animatedButtons.includes(2) ? 1 : 0,
//               transition: "transform 0.8s ease, opacity 0.8s ease",
//             }}
//           >
//             <span style={styles.icon}>🔑</span>
//             An employment that you can trust in
//           </div>
//           <div
//             style={{
//               ...styles.card,
//               ...styles.card4,
//               transform: animatedButtons.includes(3)
//                 ? "translateY(0)"
//                 : "translateY(100px)",
//               opacity: animatedButtons.includes(3) ? 1 : 0,
//               transition: "transform 0.8s ease, opacity 0.8s ease",
//             }}
//           >
//             <span style={styles.icon}>🌍</span>A diverse, international culture
//             that values your whole self
//           </div>
//         </div>
//       </div>

//       <div style={styles.imageWrapper}>
//         <img
//           src="/image/istockphoto-1205011630-612x612.jpg"
//           alt="career"
//           style={styles.image}
//         />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: "60px 40px",
//     flexWrap: "wrap",
//     backgroundColor: "#fafafa",
//     borderRadius: "12px",
//     maxWidth: "1200px",
//     margin: "40px auto",
//     boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
//   },
//   textSection: {
//     flex: 1,
//     paddingRight: "40px",
//     minWidth: "300px",
//   },
//   text: {
//     fontSize: "16px",
//     // lineHeight: "1.6",
//     marginBottom: "30px",
//     textAlign: "justify",
//     color: "black",
//     fontWeight: "bold",
//   },
//   features: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },
//   card: {
//     padding: "18px 22px",
//     borderRadius: "12px",
//     fontSize: "16px",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     fontWeight: "500",
//     color: "black",
//     boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//   },
//   card1: {
//     background: "linear-gradient(135deg, #d4b8f3ff 0%, #ffffffff 100%)",
//   },
//   card2: {
//     background: "linear-gradient(135deg, #ef8ea4ff 0%, #ffffffff 100%)",
//   },
//   card3: {
//     background: "linear-gradient(135deg, #86e5bcff 0%, #ffffffff 100%)",
//   },
//   card4: {
//     background: "linear-gradient(135deg, #ed967eff 0%, #ffffffff 100%)",
//   },
//   icon: {
//     fontSize: "24px",
//     filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.2))",
//   },
//   imageWrapper: {
//     flex: 1,
//     textAlign: "center",
//   },
//   image: {
//     width: "100%",
//     maxWidth: "500px",
//     borderRadius: "12px",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
//   },
// };

// export default CareerSection;




import React, { useEffect, useRef, useState } from "react";

const CareerSection = () => {
  const sectionRef = useRef(null);
  const [animatedButtons, setAnimatedButtons] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Trigger animation only when component enters view
            const buttons = [0, 1, 2, 3];
            buttons.forEach((buttonIndex, index) => {
              setTimeout(() => {
                setAnimatedButtons((prev) =>
                  prev.includes(buttonIndex) ? prev : [...prev, buttonIndex]
                );
              }, index * 300);
            });
            observer.unobserve(entry.target); // ensures animation happens only once
          }
        });
      },
      { threshold: 0.4 } // section should be ~40% visible to trigger
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} style={styles.container}>
      {/* Text Section */}
      <div style={styles.textSection}>
        <p style={styles.text}>
          At ENVISION, you'll supercharge your potential. You'll find your
          career. And you'll find your spark. All at a place that knows that
          helping our clients stay on top starts by putting our people first. We
          offer:
        </p>

        {/* Buttons with scroll-triggered animation */}
        <div style={styles.features}>
          {[
            { icon: "📂", text: "Career opportunities on your terms" },
            { icon: "✨", text: "Enriching job experiences" },
            { icon: "🔑", text: "An employment that you can trust in" },
            {
              icon: "🌍",
              text: "A diverse, international culture that values your whole self",
            },
          ].map((item, index) => (
            <div
              key={index}
              style={{
                ...styles.card,
                ...styles[`card${index + 1}`],
                transform: animatedButtons.includes(index)
                  ? "translateY(0)"
                  : "translateY(80px)",
                opacity: animatedButtons.includes(index) ? 1 : 0,
                transition: "transform 0.8s ease, opacity 0.8s ease",
              }}
            >
              <span style={styles.icon}>{item.icon}</span>
              {item.text}
            </div>
          ))}
        </div>
      </div>

      {/* Image Section */}
      <div style={styles.imageWrapper}>
        <img
          src="/image/istockphoto-1205011630-612x612.jpg"
          alt="career"
          style={styles.image}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "60px 40px",
    flexWrap: "wrap",
    backgroundColor: "#fafafa",
    borderRadius: "12px",
    maxWidth: "1200px",
    margin: "40px auto",
    boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
  },
  textSection: {
    flex: 1,
    paddingRight: "40px",
    minWidth: "300px",
  },
  text: {
    fontSize: "16px",
    marginBottom: "30px",
    textAlign: "justify",
    color: "black",
    fontWeight: "bold",
  },
  features: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    padding: "18px 22px",
    borderRadius: "12px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontWeight: "500",
    color: "black",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  card1: {
    background: "linear-gradient(135deg, #d4b8f3 0%, #fff 100%)",
  },
  card2: {
    background: "linear-gradient(135deg, #ef8ea4 0%, #fff 100%)",
  },
  card3: {
    background: "linear-gradient(135deg, #86e5bc 0%, #fff 100%)",
  },
  card4: {
    background: "linear-gradient(135deg, #ed967e 0%, #fff 100%)",
  },
  icon: {
    fontSize: "24px",
    filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.2))",
  },
  imageWrapper: {
    flex: 1,
    textAlign: "center",
  },
  image: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
  },
};

export default CareerSection;
